module.exports = __webpack_public_path__ + "img/profile-photo.dfdc3108.png";